import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "../../css/UserDashboard.css";
import Table from "./Table"

const UserDashboard = (props) => {
    const [githubAccounts, setGithubAccounts] = useState([])
    const [showError, setShowError] = useState({ show: false, msg: "" });
    const [uuidCredit, setUuidCredit] = useState("")
    const location = useLocation()

    useEffect( () => {
      fetchDashboard()
    }, [location, uuidCredit])

    function fetchDashboard(){
      console.log("uuidCredit with location", location.state)
      console.log("uuidCredit with local storage", localStorage.getItem('uuidCredit') )
      setUuidCredit(location.state)
      console.log(uuidCredit)
      axios.post( process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE +`/api/dashboard`,
      {
        id:uuidCredit,
      }, {headers: {
      "Content-Type": "application/json",
      }}).then((res) => {
          if(res.data!==undefined)
            setGithubAccounts(res.data)
          console.log("Data from api-node")
          res.data.map(elem=>console.log(elem))
          console.log("map works")
      }).catch((err) => {
          setShowError({
            show: true,
            msg: "Please check the url/id and submit again.",
          });
      }) 
    }

    const columns=[ {"field": "username", "header": "username"},
              {"field": "status", "header": "status"},
              {"field": "githubRating", "header": "rank"},
              {"field": "primary_language", "header": "languages"},
              {"field": "time_created", "header": "Last update time"}]

    return (
    <div className="userDashboard">
        {(uuidCredit==="") ? <>Please login to the account by using email link</> : 
          
          (githubAccounts.length === 0) ? (
            <>No analyzed github accounts</>
          ) : (
            <Table data={githubAccounts} columns={columns} />
        ) 
        }
    </div>
    )
}

export default UserDashboard
